import {Inbox, Sparkles, CheckCircle2, CircleAlert, RefreshCw, FlaskConical} from 'lucide-react';
import {Ticket, TicketCounts} from '../../types';
import {Btn, PrivacyBadge, Spinner} from '../Shared';

interface OverviewProps {tickets: Ticket[]; connected: boolean; syncing: boolean; onSync: () => void}
export const InboxOverview = ({tickets, connected, syncing, onSync}: OverviewProps) => <>
  <div className="page-intro"><div><h1 data-testid="inbox-heading">Support inbox</h1><p data-testid="inbox-subtitle">A little less sorting. A lot more helping.</p></div>
    <div className="intro-right">{tickets.some(ticket => ticket.is_sample) && <span className="sample-label" data-testid="sample-data-indicator"><FlaskConical size={12}/>Sample workspace</span>}
      <PrivacyBadge/><Btn data-testid="inbox-sync-button" onClick={onSync} disabled={syncing}>{syncing ? <Spinner/> : <RefreshCw size={12}/>} {syncing ? 'Syncing…' : connected ? 'Sync inbox' : 'Connect Gmail'}</Btn>
    </div>
  </div>
</>;

export const InboxMetrics = ({tickets, counts}: {tickets: Ticket[]; counts: TicketCounts}) => {
  const attention = tickets.filter(ticket => ticket.status !== 'resolved' && (ticket.needs_human || ticket.priority === 'Urgent')).length;
  const metrics = [
    {label: 'Open tickets', value: counts.all - counts.resolved, icon: Inbox, cls: '', hint: 'in your queue'},
    {label: 'Drafts ready', value: counts.drafted, icon: Sparkles, cls: 'green', hint: 'awaiting review'},
    {label: 'Needs attention', value: attention, icon: CircleAlert, cls: 'amber', hint: 'human touch'},
    {label: 'Resolved', value: counts.resolved, icon: CheckCircle2, cls: 'gray', hint: 'all wrapped up'},
  ];
  return <div className="metrics">{metrics.map((metric, index) => <div className="metric" key={metric.label} data-testid={`inbox-metric-${index}`}>
    <div className={`metric-symbol ${metric.cls}`}><metric.icon size={17} strokeWidth={1.6}/></div>
    <div><div className="metric-label">{metric.label}</div><div className="metric-value">{metric.value.toString().padStart(2, '0')}<small>{metric.hint}</small></div></div>
  </div>)}</div>;
};